import * as React from "react";

import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IntakeFormNotification } from "services/types/notifications";

const IntakeFormNotificationComponent = ({
  title,
  description,
  extra
}: IntakeFormNotification) => {
  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography component="span">{description}</Typography>
          <Link
            href={`/patients/${extra.patient_id}/onboardings`}
            target="_blank"
            underline="hover"
          >
            Onboarding Forms
          </Link>
        </Stack>
      }
    />
  );
};

export default IntakeFormNotificationComponent;
